export default __webpack_public_path__ + "static/media/MongoDB.c7bedc86.svg";